import { useNavigate } from 'react-router-dom';
import { Alert, Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { routesPath } from '../../common/constants/routesPath';

const VinExtractionNotAllowed = () => {
    const { t } = useTranslation('vinExtraction');
    const navigate = useNavigate();

    return (
        <Alert
            type="warning"
            showIcon
            message={t('notAllowed.title')}
            description={t('notAllowed.description')}
            action={
                <Button size="small" onClick={() => navigate(routesPath.ROOT.USER_SETTINGS)}>
                    {t('notAllowed.openSettings')}
                </Button>
            }
        />
    );
};

export default VinExtractionNotAllowed;
